import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { FindDistritoDto } from '@/api.types.extra';
import { Link } from 'react-router-dom';
import { ReadDistritoDto } from '@/api.types';
import { readDistrito } from './distrito.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function DistritosIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadDistritoDto[], number]>();
  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    const filters: FindDistritoDto = {
      skip: (tableState.currentPage - 1) * tableState.pageSize,
      take: tableState.pageSize,
      comDefensoria: true,
      comMovimentacoes: true,
      orderBy: 'ASC',
      orderField: 'nome'
    }

    readDistrito(filters)
      .then((res) => {
        setRegistros(res);
      })
      .catch((res) => {
        toast.error(String(res));
      });
  }

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Distrito_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  let colunas: Column<ReadDistritoDto>[] = [
    { key: "ordem", header: "Ordem" },
    { key: "nome", header: "Nome" },
    { key: "defensoria.nome", header: "Defensoria" },
    { key: "movimentacoes.length", header: "Movimentações" },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Distrito_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <div className="row">
      <div className="col-12">
        <h3>Distritos</h3>
        <span className="blockquote-footer pb-4 text-end">
          Distritos das defensorias.
        </span>
      </div>
      <hr className="pb-4" />
      {registros && <DataTable
        columns={colunas}
        data={registros?.[0]}
        initialSortKey='nome'
        onChange={handleBuscar}
        serverSide={true}
        states={tableState}
        totalRecords={registros?.[1]}
      />}

    </div>
  );
}
